/* Scentology — WhatsApp review screenshots lightbox */
(function () {
  'use strict';

  if (window.__scWaReviews) return;
  window.__scWaReviews = true;

  var lightbox = document.querySelector('[data-wa-lightbox]');
  if (!lightbox || typeof lightbox.showModal !== 'function') return;
  var img = lightbox.querySelector('[data-wa-img]');

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-wa-open]');
    if (card) {
      e.preventDefault();
      img.src = card.getAttribute('data-full') || '';
      img.alt = card.getAttribute('data-alt') || '';
      lightbox.showModal();
      return;
    }
    if (e.target.closest('[data-wa-close]')) {
      lightbox.close();
      return;
    }
    /* click on the backdrop (outside the image) closes */
    if (e.target === lightbox) lightbox.close();
  });

  lightbox.addEventListener('close', function () {
    img.src = '';
    img.alt = '';
  });
})();
